import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { ListItem, List, Text } from "@chakra-ui/react";

const colorList = [
  "#AF5EDA",
  "#D07F0B",
  "#453C25",
  "#6D43F9",
  "#C16F89",
  "#446B5A",
  "#D44415",
  "#E30B93",
  "#2941FB",
  "#CE1FB8",
  "#FA1355",
  "#A9104C",
  "#33244E",
  "#B41928",
  "#89662A",
  "#CF4203",
  "#E48F9B",
  "#982D98",
  "#7A0E65",
  "#AA1F5E",
  "#9375B4",
  "#E33BE2",
  "#8878D2",
  "#058164",
  "#318F82",
  "#17587D",
  "#FA5B7B",
  "#D64F1E",
  "#D79FEE",
  "#B06524",
  "#EF9D17",
  "#9A7409",
  "#A30C0C",
  "#A092E8",
  "#8AACE0",
  "#7C98AB",
  "#945549",
];

const toPercent = (decimal, fixed = 0) => `${(decimal * 100).toFixed(fixed)}%`;

// const getPercent = (value, total) => {
//   const ratio = total > 0 ? value / total : 0;

//   return toPercent(ratio, 2);
// };

const renderTooltipContent = (o) => {
  const { payload, label } = o;
  const total = payload.reduce((result, entry) => result + entry.value, 0);

  return (
    <div className="customized-tooltip-content">
      <Text color="white" p={1}>
        {label}
      </Text>
      <List className="list">
        {payload.map((entry, index) => (
          <ListItem
            key={`item-${index}`}
            color="white"
            background={entry.color}
            p="1px"
          >
            {`[${entry.name.slice(0, 5)}...${entry.name.slice(
              -5,
            )}]: ${entry.value.toString()}`}
          </ListItem>
        ))}
      </List>
    </div>
  );
};

const StackAreaChart = ({ holders, data }) => {
  return (
    <ResponsiveContainer width="100%" height={640}>
      <AreaChart
        height={640}
        data={data}
        stackOffset="expand"
        reverse
        margin={{
          top: 10,
          right: 30,
          left: 0,
          bottom: 0,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis reversed />
        <Tooltip content={renderTooltipContent} />
        {holders.map((holder, index) => {
          return (
            <Area
              key={`area-${index}`}
              type="monotone"
              stackId="1"
              dataKey={holder}
              stroke={colorList[index]}
              fill={colorList[index]}
            />
          );
        })}
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default StackAreaChart;
